import CAPostalCodeFormatter from '@banking/ui/utils/field-kit-formatters/postal-code/ca-postal-code-formatter';
import GBPostalCodeFormatter from '@banking/ui/utils/field-kit-formatters/postal-code/gb-postal-code-formatter';
import USPostalCodeFormatter from '@banking/ui/utils/field-kit-formatters/postal-code/us-postal-code-formatter';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
export default function (country) {
  switch (country) {
    case Country.CA:
      return new CAPostalCodeFormatter();
    case Country.GB:
      return new GBPostalCodeFormatter();
    case Country.US:
      return new USPostalCodeFormatter();
    default:
      throw new Error(`No PostalCodeFormatter exists for Country (countryCode: ${country})`);
  }
}